<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <div class="flex xs12 sm2">
                <v-select
                        :items="[{
                          text: '문제발생 고유번호',
                          value: 'id'
                        },
                        {
                          text: '상태',
                          value: 'state'
                        }]"
                        name="header"
                        v-model="searchFormModel.filter"
                        label="header"
                ></v-select>
              </div>

              <v-text-field
                      v-show="searchFormModel.filter !== 'state'"
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'state'">
                <v-select
                        :items="passengerUsageProblemState"
                        label="선택"
                        item-text="text"
                        item-value="state"
                        single-line
                        v-model="searchFormModel.filterText"
                >
                </v-select>
              </div>
              <v-btn icon @click="searchFilter">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="id"
                must-sort
                :total-items="totalItems"
                :loading="loading"
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">           
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center"><a @click="openDetail(props.item.passengerUsageId)">{{ props.item.passengerUsageId }}</a></td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">{{ props.item.modDate }}</td>
                  <td class="text-sm-center">
                    <v-select
                            :items="passengerUsageProblemState"
                            label="State"
                            item-text="text"
                            item-value="state"
                            single-line
                            :value="props.item.state"
                            @change="changeState(props.item.id, $event)">
                    </v-select>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import PassengerUsageProblemState  from '@/api/passengerUsageProblemState';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'id',
        filterText: ''
      },
      totalItems: 0,
      loading: true,
      complex: {
        headers: [
          {
            text: '문제발생 고유번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '승객 이용이력 고유번호',
            value: 'passengerUsageId',
            align: 'center'
          },
          {
            text: '등록일시',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '수정일시',
            value: 'modDate',
            align: 'center'
          },
          {
            text: '상태',
            value: 'state',
            align: 'center'
          }
        ],
        items: []
      },
      passengerUsageProblemState: PassengerUsageProblemState
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'PassengerUsageProblemHistoryPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'searchPassengerUsageProblemRecords',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };
      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          if (data.statusCode != null && data.statusCode != '200'){
            throw data.message;
          }

          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          this.loading = false;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changeState (id, state) {
      const parameters = {
        method: 'updatePassengerUsageProblemRecord',
        'id': id,
        'state': state
      };

      this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                top.getApp.progress.dialog = false;
              })
              .catch((error) => {
                if (top.getApp.commonError == null) {
                  alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                }
                top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
    },
    openDetail (id) {
      top.getApp.addPrevData('PassengerUsageProblemHistoryPage', this.pagination, this.searchFormModel);
      this.$router.push('/usage/passengerUsageHistory/' + id);
    },
    searchFilter () {
      this.banbanCreated();
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/usage/PassengerUsageProblemHistory.vue